import { render, staticRenderFns } from "./com-box1.vue?vue&type=template&id=3a5f6fbf&scoped=true&"
import script from "./com-box1.vue?vue&type=script&lang=js&"
export * from "./com-box1.vue?vue&type=script&lang=js&"
import style0 from "./com-box1.vue?vue&type=style&index=0&id=3a5f6fbf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5f6fbf",
  null
  
)

export default component.exports